import React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { observer } from 'mobx-react';
import { Header } from './Header';
import { Filters } from './Filters';
import { ReviewsList } from './ReviewsList';
import { SortReview } from './SortReview';
import { Message } from './Messages';
import { MessageType } from './Messages/Message';
import { InterestsFilterMobile } from './Filters/InterestsFilterMobile';
import { FiltersMobile } from './FiltersMobile';
import { ReviewsPlaceholder } from './ReviewsPlaceholder';
import { ReviewsSourcesToggle } from './ToggleTopHotelsReviews';
import { TopHotelsWidget } from './TopHotelsWidget';
import { ReviewsSources } from '../../../models/hotel-reviews';
import S from '../../../stores';

import cl from 'classnames';

export interface HotelReviewsProps {}

interface StyledHotelReviewsProps
    extends JSSClassesProps<ComponentJSSClasses>,
        HotelReviewsProps {}

export const HotelReviews = observer((props: StyledHotelReviewsProps) => {
    const { classes: c } = props;
    const { isLoading } = S.hotelReviews;
    const isMobile = S.hotelReviews.isMobile || S.hotelReviews.isTabletS;

    return (
        <div className={c.wrapper}>
            <div
                className={cl(c.headingWrapper, {
                    [c.noReviewsWrapper]: S.hotelReviews.hotelWithoutReviews
                })}
            >
                <h2 className={c.heading}>Отзывы об отеле</h2>
            </div>
            {isLoading && <ReviewsPlaceholder />}
            {S.hotelReviews.showReviewsBlock && (
                <div className={c.content}>
                    <ReviewsSourcesToggle />
                    {isMobile && S.hotelReviews.mobileFiltersOpen && <FiltersMobile />}
                    {S.hotelReviews.selectedReviewsSources === ReviewsSources.Others
                    ? (
                        <div className={c.mainReviewsWrapper}>
                            <Header
                                rating={S.hotelReviews.averageReviewsRating}
                                detailRating={S.hotelReviews.reviewsOverview.additionalRatingsAverage}
                                detailRatingCount={S.hotelReviews.reviewsOverview.additionalRatingsCount}
                                reviewAmount={S.hotelReviews.totalReviewAmount}
                                reviewAmountByRating={S.hotelReviews.reviewsAmountByGrade}
                                isMobile={isMobile}
                            />
                            <div className={c.mainWrapper}>
                                {!isMobile && <Filters />}
                                <div className={c.mainContent}>
                                    {isMobile && (
                                        <InterestsFilterMobile
                                            tags={S.hotelReviews.availableTags}
                                        />
                                    )}
                                    <SortReview
                                        reviewAmount={S.hotelReviews.filteredReviewAmount}
                                        isMobile={isMobile}
                                    />
                                    <ReviewsList reviewList={S.hotelReviews.hotelReviews} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <TopHotelsWidget
                            topHotelsId={S.hotelReviews.topHotelsId}
                            topHotelsUrl={S.hotelReviews.topHotelsHotelUrl}
                        />
                        )
                    }
                </div>)
            }
            {S.hotelReviews.hotelWithoutReviews &&
                <div className={c.noReviewsWrapper}>
                    <Message type={MessageType.NoReviews} />
                </div>
            }
        </div>
    );
});
